import { render } from "./foldersend_popup.vue?vue&type=template&id=7628aa8e&scoped=true"
import script from "./foldersend_popup.js?vue&type=script&lang=js"
export * from "./foldersend_popup.js?vue&type=script&lang=js"

import "./foldersend_popup.vue?vue&type=style&index=0&id=7628aa8e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7628aa8e"]])

export default __exports__